import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  CreateNoteDocumentFieldKey,
  CreateNoteDocumentFieldValue,
  CreateNoteDocumentState,
} from '@/domains/notes/store/types/createNoteDocumentSliceTypes';
import { SelectOption } from '@/features/editMode/types/selectOption';
import { createDocumentInitialState } from '@/domains/notes/store/constants/createNoteDocumentSliceConstants';

const createNoteDocumentSlice = createSlice({
  name: 'createNoteDocument',
  initialState: createDocumentInitialState,
  reducers: {
    uploadDocument: () => {},
    updateCreateDocumentStepValues: <K extends CreateNoteDocumentFieldKey>(
      state: CreateNoteDocumentState,
      action: PayloadAction<{ step: K; value: CreateNoteDocumentFieldValue<K> }>,
    ) => {
      const { step, value } = action.payload;
      state.createDocumentSteps[step] = value;
    },
    resetCreateDocumentState: () => createDocumentInitialState,
    setCreateDocumentLoadingStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isCreateDocumentLoading = payload;
    },
    getCreateDocumentClaims: (_, _action: PayloadAction<string>) => {},
    getCreateDocumentClaimsSuccess: (state, { payload }: PayloadAction<SelectOption[]>) => {
      state.claimOptions = payload;
    },
    getCreateDocumentClaimants: (_, _action: PayloadAction<string>) => {},
    getCreateDocumentClaimantsSuccess: (state, { payload }: PayloadAction<SelectOption[]>) => {
      state.claimantOptions = payload;
    },
    setCreateDocumentOptionsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isOptionsLoading = payload;
    },
  },
  selectors: {
    selectCreateDocumentSteps: (state) => state.createDocumentSteps,
    selectCreateDocumentIsLoading: (state) => state.statuses.isCreateDocumentLoading,
    selectCreateDocumentClaimOptions: (state) => state.claimOptions,
    selectCreateDocumentClaimantOptions: (state) => state.claimantOptions,
    selectCreateDocumentOptionsLoading: (state) => state.statuses.isOptionsLoading,
  },
});

export const {
  updateCreateDocumentStepValues,
  resetCreateDocumentState,
  setCreateDocumentLoadingStatus,
  uploadDocument,
  getCreateDocumentClaims,
  getCreateDocumentClaimsSuccess,
  setCreateDocumentOptionsLoading,
  getCreateDocumentClaimants,
  getCreateDocumentClaimantsSuccess,
} = createNoteDocumentSlice.actions;

export const {
  selectCreateDocumentSteps,
  selectCreateDocumentIsLoading,
  selectCreateDocumentClaimOptions,
  selectCreateDocumentOptionsLoading,
  selectCreateDocumentClaimantOptions,
} = createNoteDocumentSlice.selectors;

export const createNoteDocumentReducer = createNoteDocumentSlice.reducer;
export const createNoteDocumentReducerPath = createNoteDocumentSlice.reducerPath;
